import { useMemo } from "react";
import { type AgGrid } from "@jsq/ds/core";
import { personsColumn, sourceDocumentColumn, TaxOverviewSection } from "./TaxOverviewSection";
import { type CrsOverviewRow } from "./utils";

export type CrsOverviewSectionProps = {
  caseId: number;
  rows: CrsOverviewRow[];
  onAddDocument: (row: CrsOverviewRow) => void;
  onOpenPersons: (row: CrsOverviewRow) => void;
  readonly?: boolean;
};

const positionColumn: AgGrid.ColDef<CrsOverviewRow> = {
  field: "positionLabel",
  headerName: "Position",
  minWidth: 432,
};

export const CrsOverviewSection = ({
  caseId,
  rows,
  onAddDocument,
  onOpenPersons,
  readonly = false,
}: CrsOverviewSectionProps) => {
  const columnDefs = useMemo<AgGrid.ColDef<CrsOverviewRow>[]>(
    () => [
      positionColumn,
      sourceDocumentColumn<CrsOverviewRow>(
        caseId,
        "crsSourceDocument",
        "CRS source document",
        onAddDocument,
        readonly,
      ),
      personsColumn<CrsOverviewRow>(
        "crsControllingPerson",
        "CRS controlling person",
        onOpenPersons,
      ),
    ],
    [caseId, onAddDocument, onOpenPersons, readonly],
  );
  return (
    <TaxOverviewSection
      title="CRS Overview"
      helpText="Describes the CRS source documents (position-specific) assigned to positions associated with this profile and the individuals identified as Controlling Persons based on the investor's tax document."
      rows={rows}
      columnDefs={columnDefs}
    />
  );
};
